module.exports = __webpack_public_path__ + "static/media/doctor.9066d40b.png";